import React from 'react';
import '../pagecomponent/navbar/navbaradh1.css';
import Navbaradh1 from '../pagecomponent/navbar/navbaradh1.js';
//import '../pagecomponents/performance/perfomance.css';
//import Perfomance from '../pagecomponents/performance/perfomance';

import '../pagecomponent/navbar/navbaradmin.css';
import Navbaradmin from '../pagecomponent/navbar/navbaradmin.js';

import '../../../../libraryportal/pagecomponents/dashboard/dashboardmenu.css';
import Dashboardmenup from '../../../../libraryportal/pagecomponents/dashboard/dashboardmenu.js';

import Webstats from '../pagecomponent/websitestats/webstats.js';
import '../pagecomponent/websitestats/webstats.css';

import Classlistpagenw from '../pagecomponent/infolist/classlist.js';





//intial build then rome to correct place
//import '../pagecomponents/outline/outline.css';
//import Outline from '../pagecomponents/outline/outline'; 

function Classlistpagen() {
    return (
        <>
            <Navbaradmin />

            <Dashboardmenup />

            <Classlistpagenw/>


           
            
        </>
    )
}

export default Classlistpagen;